/** Only successful writes or decrypted remote entries acknowledge a history
 * item. Failures remain retryable; a local UI entry alone is not an ACK. */
export class AcknowledgedHistoryWrites {
  private readonly acknowledged = new Set<string>();
  private readonly pending = new Map<string, Promise<void>>();

  acknowledge(key: string): void {
    this.acknowledged.delete(key);
    this.acknowledged.add(key);
    while (this.acknowledged.size > 500)
      this.acknowledged.delete(this.acknowledged.values().next().value!);
  }

  run(key: string, write: () => Promise<void>): Promise<void> {
    if (this.acknowledged.has(key)) return Promise.resolve();
    const existing = this.pending.get(key);
    if (existing) return existing;
    const work = Promise.resolve()
      .then(write)
      .then(() => this.acknowledge(key));
    this.pending.set(key, work);
    const clear = () => {
      if (this.pending.get(key) === work) this.pending.delete(key);
    };
    void work.then(clear, clear);
    return work;
  }
}
